import { useCurrentCampagne } from "@common/hooks/campagne";
import { CampagneStatut } from "@common/services";
import React from "react";
import { Navigate, Outlet } from "react-router-dom";

export const RequireCampagne = () => {
  const { campagne } = useCurrentCampagne();

  if (!campagne) return;

  return (campagne.statut !== CampagneStatut.EN_COURS)
          ? <Navigate to={'/campagne-terminee'} replace />
          : <Outlet />;
}